import React, { useEffect, useRef } from 'react';
import './Spheres3D.css';

/* ------------------------------------------------------------------
 * Spheres3D
 * ------------------------------------------------------------------
 * Loads the luminar.games "singularity" scene – a dense, physics-
 * simulated 3D sphere field – as the single fixed background for
 * the whole site. Hero is transparent so the spheres read full-
 * strength; every other section sits on a tuned `.section-glass`
 * plate (12px blur, no saturate pass) that softens the animated
 * field beneath editorial copy without pegging the GPU.
 *
 * The scene is a self-contained ES module (see /public/singularity-
 * scene.js) that brings its own three.js. We load it at runtime via
 * a native dynamic import so webpack leaves it alone and the 800 KB
 * payload never hits the main bundle.
 * ------------------------------------------------------------------ */

// Using `new Function` forces a real, runtime `import(…)` that
// webpack won't try to statically resolve or bundle.
// eslint-disable-next-line no-new-func
const nativeImport = new Function('u', 'return import(u)');

const Spheres3D = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    let disposer = null;
    let cancelled = false;

    const url = `${process.env.PUBLIC_URL || ''}/singularity-scene.js`;
    nativeImport(url)
      .then((mod) => {
        if (cancelled || !mod?.createSingularityScene) return;
        disposer = mod.createSingularityScene(container);
      })
      .catch((err) => {
        console.warn('Spheres3D: failed to load singularity scene', err);
      });

    return () => {
      cancelled = true;
      try {
        disposer?.dispose?.();
      } catch {
        /* already disposed */
      }
    };
  }, []);

  return <div ref={containerRef} className="spheres3d-container" aria-hidden />;
};

export default Spheres3D;
